import { Parameters } from '../../../appConfig'
import {MsalSession} from "@/uptk/core/api/auth";
import { getActiveConfig } from "../../../authConfig";

const config = getActiveConfig();

export const azureFrontUrl = () => {
    
    return  config.auth.frontURL
};
export const apiAzureUrl = () => {
    
    return  config.auth.backendURL;
};
export const apiLocalHttp = config?.auth?.backendURL || 'http://localhost:8080';
export const apiLocalHttps = config?.auth?.backendURL || 'https://localhost:8080';
export const frontLocalHttp = import.meta.env.VITE_FRONT_URL || 'http://localhost:3000';
export const frontLocalHttps = import.meta.env.VITE_FRONT_URL_HTTPS || 'https://localhost:3000';
